const getChildPages = (state, sectionId) =>
  state.guidebook.working.childPages.get(sectionId) || [];

export default getChildPages;
